const FEATURES = [
  {
    icon: 'ri-shield-check-line',
    title: 'Military-Grade Security',
    description:
      'Our VPN uses 256-bit AES encryption — the same standard trusted by governments and financial institutions worldwide.',
    accent: 'bg-emerald-50 text-emerald-600',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Peak Performance',
    description:
      'AMIK Cleaner intelligently frees up storage and optimizes memory so your iPhone always runs at its best.',
    accent: 'bg-amber-50 text-amber-600',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Zero-Log Privacy',
    description:
      'We never track, store, or sell your data. Your online activity remains completely private — always.',
    accent: 'bg-rose-50 text-rose-600',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'iOS Native Design',
    description:
      'Built exclusively for iOS, our apps follow Apple\'s Human Interface Guidelines for a seamless, intuitive experience.',
    accent: 'bg-sky-50 text-sky-600',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Dedicated Support',
    description:
      'Our expert team is always available to help. Fast, friendly, and knowledgeable support whenever you need it.',
    accent: 'bg-violet-50 text-violet-600',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Continuous Updates',
    description:
      'We constantly improve our apps with new features, security patches, and performance enhancements.',
    accent: 'bg-teal-50 text-teal-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-24 md:py-32 bg-[#F7F7F5]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <p className="text-xs font-semibold tracking-widest text-emerald-600 uppercase mb-3">Why Choose Us</p>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
              Trusted by Thousands<br />
              <span className="italic font-light text-gray-400">of Users Worldwide</span>
            </h2>
          </div>
          <p className="text-gray-500 text-sm max-w-xs lg:text-right leading-relaxed">
            Performance-driven. Privacy-first.<br />Always improving.
          </p>
        </div>

        {/* Highlight cards */}
        <div className="mb-8">
          {/* Big stat card 1 only */}
          <div className="bg-gray-900 rounded-3xl p-8 md:p-10 flex flex-col justify-between min-h-[220px] max-w-2xl">
            <div>
              <p className="text-6xl md:text-7xl font-extrabold text-white leading-none mb-3">99%</p>
              <p className="text-emerald-400 font-semibold text-base">App Uptime Reliability</p>
              <p className="text-gray-400 text-sm mt-2">Across all supported iOS versions and devices.</p>
            </div>
            <p className="text-gray-500 text-xs italic mt-6">&ldquo;Always on. Always secure.&rdquo;</p>
          </div>
        </div>

        {/* Feature grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURES.map((feat) => (
            <div
              key={feat.title}
              className="bg-white rounded-2xl p-6 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl mb-4 ${feat.accent}`}>
                <i className={`${feat.icon} text-lg`} />
              </div>
              <h4 className="font-bold text-gray-900 text-base mb-2">{feat.title}</h4>
              <p className="text-gray-500 text-sm leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
